import type { AppButtonProps } from "@/shared/Components/AppButton";
import type { FC } from "react";
import { SettingsButton } from "../SettingsButton";
import styles from "./styles.module.scss";

type Props = Pick<AppButtonProps, "onClick"> & { title: string };

export const SettingsTitle: FC<Props> = ({ title, onClick }) => {
  return (
    <div className={styles["settings-title"]}>
      <p className={styles["title"]}>{title}</p>
      <SettingsButton onClick={onClick} />
    </div>
  );
};
